import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { PropType, computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { PolicySettingType, PolicyType } from '@/views/dashboard/_enum/policy-type'
import { PolicyCommonService, StrategyListDataCommon } from '@/views/dashboard/policy/policy-common.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'policy-select',
  props: {
  strategyType: {
    type: Number as PropType<PolicyType>,
    default: undefined
  },
  dataType: {
    type: String as PropType<PolicySettingType>,
    default: undefined
  },
  /** 不传时使用公用列名 `listColumns.triggerPolicy` */
  placeholder: {
    type: String as PropType<string | undefined>,
    default: undefined,
  },
  modelValue: {
    type: [Number, String],
  },
},
  emits: ['change', 'update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props

const emits = __emit

const { t, locale } = useI18n()
const effectivePlaceholder = computed(() => {
  void locale.value
  if (props.placeholder !== undefined) {
    return props.placeholder
  }
  return t('listColumns.triggerPolicy')
})

const injector = useReflectiveInjector([PolicyCommonService])
const policyCommonService = injector.get(PolicyCommonService)
const strategyList = ref<StrategyListDataCommon[]>([])

function getStrategyList () {
  policyCommonService.getStrategyList({
    strategy_type: props.strategyType,
    data_type: props.dataType,
    page: 1,
    limit: 9999,
  }).then(res => {
    strategyList.value = res.data || []
  })
}

function handleChange (val) {
  // 不允许抛出空字符串
  val = val === '' ? undefined : val
  emits('update:modelValue', val)
  emits('change', val)
}

getStrategyList()

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(_component_el_select, _mergeProps({
    "model-value": __props.modelValue,
    placeholder: effectivePlaceholder.value
  }, _ctx.$attrs, {
    filterable: "",
    clearable: "",
    onChange: handleChange
  }), {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(strategyList.value, (item, index) => {
        return (_openBlock(), _createBlock(_component_el_option, {
          key: index,
          value: item.id,
          label: item.name
        }, null, 8, ["value", "label"]))
      }), 128))
    ]),
    _: 1
  }, 16, ["model-value", "placeholder"]))
}
}

})